import React, { useContext, useState } from "react";

// context
import { compareDataContext } from "../../contexts/CompareContext";
import { Link } from "react-router-dom";
import { toFarsiNumber } from "../../helper/helper";
import { CartDataContext } from "../../contexts/CartContext";

const Compare = () => {
  const { compareData, setCompareData, openCompare, setOpenCompare } =
    useContext(compareDataContext);

    const { cart, setCart, updateCart } = useContext(CartDataContext);


  const [openList, setOpenList] = useState(false);

  // delete product from compare list
  const deleteFromCompare = (data) => {
    const newData = compareData.filter((c) => c.id !== data.id);

    setCompareData(newData);
  };

  // open compare list
  const openCompareList = () => {
    setOpenList(!openList);
  };

  // close compare list
  const closeCompare = () => {
    setOpenCompare(false);
    setOpenList(false);
  };

  return (
    <div
      className={`fixed w-full ${openCompare ? "flex" : "hidden"} flex-col ${
        openList ? "h-full" : "h-auto"
      } bg-white bottom-0 z-[100000] rounded-t-2xl shadow-[0px_5px_25px_rgba(79,105,139,.09)]`}
    >
      {/* compare table */}
      {openList && (
        <div className="h-full w-full bg-indigo-50 p-6">
          <div className="scroll-style w-full h-full rounded-xl bg-white max-h-[650px] overflow-y-auto">
            <table class="compare-table min-w-[1000px] scroll-auto">
              <thead className="">
                <tr>
                  <th className="text-lg font-black text-gray-800 !w-[0%]"></th>
                  {compareData.map((data) => (
                    <th className="text-lg w-1/3 font-black text-gray-800">
                      <h2>{data.title}</h2>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr key="" className="w-1/3">
                  <td className="!text-right">
                    <span className="block w-28">تصویر محصول</span>
                  </td>
                  {compareData.map((data) => (
                    <td>
                      <div className="flex justify-center items-center">
                        <img
                          src={`https://api.myunibest.ir/${data.image[0].image}`}
                          className="w-64 h-64"
                          alt=""
                        />
                      </div>
                    </td>
                  ))}
                </tr>
                <tr key="">
                  <td className="!text-right">
                    <span className="block w-28">قمیت</span>
                  </td>
                  {compareData.map((data) => (
                    <td className="w-1/3">
                      <span className="text-xl text-gray-800 font-black">
                        {toFarsiNumber(data.price)}
                      </span>
                    </td>
                  ))}
                </tr>

                <tr key="">
                  <td className="!text-right">
                    <span className="block w-28">موجودی</span>
                  </td>
                  {compareData.map((data) => (
                    <td className="w-1/3">
                      <div className="flex justify-center items-center gap-2">
                        <span className="text-xl text-gray-800 font-black">
                          {toFarsiNumber(data.qty)}
                        </span>
                        <span>عدد در انبار</span>
                      </div>
                    </td>
                  ))}
                </tr>

                {/* <tr key="">
                  <td className="!text-right">
                    <span className="block w-28">سبد خرید</span>
                  </td>
                  {compareData.map((data) => (
                    <td className="w-1/3">
                      <div className="flex justify-center items-center">
                        <button className="w-fit flex shadow-lg shadow-blue-100 items-center gap-2 px-4 py-2 text-white rounded-xl bg-gradient-to-tl from-blue-600 to-blue-300">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            class="w-5 h-5 fill-white"
                          >
                            <path d="M2.25 2.25a.75.75 0 0 0 0 1.5h1.386c.17 0 .318.114.362.278l2.558 9.592a3.752 3.752 0 0 0-2.806 3.63c0 .414.336.75.75.75h15.75a.75.75 0 0 0 0-1.5H5.378A2.25 2.25 0 0 1 7.5 15h11.218a.75.75 0 0 0 .674-.421 60.358 60.358 0 0 0 2.96-7.228.75.75 0 0 0-.525-.965A60.864 60.864 0 0 0 5.68 4.509l-.232-.867A1.875 1.875 0 0 0 3.636 2.25H2.25ZM3.75 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM16.5 20.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z" />
                          </svg>

                          <span>افزودن به سبد خرید</span>
                        </button>
                      </div>
                    </td>
                  ))}
                </tr> */}

                <tr key="">
                  <td className="!text-right">
                    <span>توضیحات</span>
                  </td>
                  {compareData.map((data) => (
                    <td className="w-1/3">
                      <p className="">{data.description}</p>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}

      <div className="w-full self-end flex justify-between items-center px-6 min-h-[80px]">
        <button
          onClick={closeCompare}
          className="w-11 h-11 flex justify-center items-center rounded-lg bg-red-50"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-6 h-6 stroke-red-600"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18 18 6M6 6l12 12"
            />
          </svg>
        </button>

        {compareData.length > 0 ? (
          <div className="flex items-center flex-row-reverse gap-4">
            <button
              onClick={openCompareList}
              className="h-11 px-6 w-fit flex items-center gap-2 bg-gradient-to-tl from-blue-600 to-blue-300 rounded-lg text-white"
            >
              <span>مقایسه</span>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-5 h-5 stroke-white"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="m19.5 8.25-7.5 7.5-7.5-7.5"
                />
              </svg>
            </button>

            {compareData.map((data) => (
              <div className="relative">
                <button
                  onClick={() => deleteFromCompare(data)}
                  className="w-5 h-5 absolute top-0 right-0 flex justify-center items-center rounded-lg bg-red-50"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-3 h-3 stroke-red-600"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6 18 18 6M6 6l12 12"
                    />
                  </svg>
                </button>
                <Link to={`/shop/${data.slug}`}>
                  <img
                    src={`https://api.myunibest.ir/${data.image[0].image}`}
                    className="h-16 w-16 object-cover"
                    alt=""
                  />
                </Link>
              </div>
            ))}
          </div>
        ) : (
          <span className="text-gray-800">لیست مقایسه شما خالی است !</span>
        )}
      </div>
    </div>
  );
};

export default Compare;
